/* eslint-disable react/prop-types */
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	InputAdornment,
	TextField,
	Tooltip
} from "@material-ui/core";
import { Chip } from "@mui/material";
import SearchIcon from "@material-ui/icons/Search";
import lod_ from "lodash";
import React, { forwardRef, memo, useEffect } from "react";
import cockpitActions from "../../../redux/actions/cockpitActions";
import userGroupActions from "../../../redux/actions/userGroupActions";
import i18n from "i18next";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getRedirectionDialogSelector } from "redux/selectors/cockpitSelectors.js";
import { ModalAssignContact } from "./AssignationConvContact";

/**
 *
 */
const RedirectionDialogUsers = forwardRef(
	({ showRedirectionSuccessPopup, handleCloseUsersRedirectionDialog, open }, ref) => {
		const dispatch = useDispatch();
		const { selectedConversation } = useSelector(state => state.cockpit);
		let { selectedAssistantID, userStatus, userGroup, resolverGroup } = useSelector(
			getRedirectionDialogSelector,
			shallowEqual
		);
		const [search, setSearch] = React.useState("");
		const [openModalAssignContact, setOpenModalAssignContact] = React.useState(false);
		const [convContact, setConvContact] = React.useState([]);
		const [payloadRes, setPayloadRes] = React.useState({});

		// Refresh the group's users (and their vacationMode) each time the dialog opens,
		// so another agent's vacation status set from a different session isn't stale
		useEffect(() => {
			if (open && selectedAssistantID) {
				dispatch(userGroupActions.updateUsersGroups(selectedAssistantID));
			}
		}, [open]);

		/**
		 *
		 * @param {*} event
		 */
		const handleSearchChange = event => {
			setSearch(event.target.value);
		};

		/**
		 * Reset Assign Modal state on close modal
		 */
		useEffect(() => {
			if (openModalAssignContact === false) {
				setConvContact([]);
				setPayloadRes({});
			}
		}, [openModalAssignContact]);

		/**
		 * Event handler to check if the conversation needs to be assigned to a contact before redirection
		 * @param {*} res
		 */
		const handleNeedConv = (res, user) => {
			let cloneRes = lod_.cloneDeep(res);
			cloneRes.redirectTo = user;
			setPayloadRes(cloneRes);
			setConvContact(cloneRes?.checkNeed?.conversations);
			setOpenModalAssignContact(true);
		};

		/**
		 *
		 * @param {*} selectedConversation
		 * @param {*} user
		 */
		const handleUserRedirection = (selectedConversation, user) => {
			if (lod_.has(userStatus, "auth.user")) {
				dispatch(
					cockpitActions.redirectConversationToUser(selectedConversation, user, false, res =>
						res?.checkNeed?.need === true
							? handleNeedConv(res, user)
							: showRedirectionSuccessPopup()
					)
				);
				handleCloseUsersRedirectionDialog();
			}
		};

		const currentUser = selectedConversation?.agent?.uid;

		return (
			<div>
				<Dialog
					fullWidth
					maxWidth="md"
					open={open}
					onClose={handleCloseUsersRedirectionDialog}
					aria-labelledby="form-dialog-title"
				>
					<DialogTitle id="form-dialog-title">{i18n.t("COC.Redirect")}</DialogTitle>
					<DialogContent dividers>
						{selectedConversation && userGroup.users && userGroup.users.length > 0 && (
							<>
								{" "}
								<Box m={1}>
									<TextField
										fullWidth
										label=""
										variant="outlined"
										size="small"
										onChange={handleSearchChange}
										InputProps={{
											startAdornment: (
												<InputAdornment position="start">
													<SearchIcon />
												</InputAdornment>
											)
										}}
									/>
								</Box>
								<span
									className="tagListForm"
									style={{
										display: "flex",
										flexWrap: "wrap",
										width: "100%"
									}}
								>
									{userGroup.users
										.filter(user => {
											if (resolverGroup) {
												if (Array.isArray(resolverGroup)) {
													if (!user.groups.some(grp => resolverGroup.includes(grp))) return false;
												} else if (!user.groups.includes(resolverGroup)) {
													return false;
												}
											} else {
												return false;
											}

											if (search.trim().length >= 0) {
												let fullSearch =
													(user.name || "") + " " + (user.surname || "") + " " + user._id;
												return fullSearch.toLowerCase().includes(search.toLowerCase());
											} else {
												return true;
											}
										})
										.sort((a, b) => a.name.localeCompare(b.name))
										.map(user => {
											const userOnVacation = user?.cockpitSettings?.vacationMode;
											return (
												<Tooltip
													title={
														userOnVacation
															? i18n.t("COC.assignErrorUserOnVacation")
															: "Rediriger à l'utilisateur " +
																user.name +
																" " +
																user.surname +
																" | " +
																user._id
													}
													key={user._id}
												>
													<span style={{ margin: "1%" }}>
														<Chip
															style={{ textTransform: "capitalize" }}
															label={user.name + " " + user.surname}
															color={currentUser === user._id ? "primary" : "default"}
															clickable={!userOnVacation}
															disabled={userOnVacation}
															onClick={() =>
																!userOnVacation && handleUserRedirection(selectedConversation, user)
															}
														/>
													</span>
												</Tooltip>
											);
										})}
								</span>
							</>
						)}
					</DialogContent>
					<DialogActions>
						<Button onClick={handleCloseUsersRedirectionDialog} color="primary">
							{`${i18n.t("COC.Cancel")}`}
						</Button>
					</DialogActions>
				</Dialog>

				<ModalAssignContact
					openModal={openModalAssignContact}
					payloadRes={payloadRes}
					setOpenModal={setOpenModalAssignContact}
					convContact={convContact}
				/>
			</div>
		);
	}
);

const MemoizedRedirectionDialogUsers = memo(RedirectionDialogUsers);
export default MemoizedRedirectionDialogUsers;
